import React, { useState } from 'react';
import ProgressGraphsBlock from './ProgressGraphsBlock';

const ProgressGraphContainer = ({
  title,
  xAxis,
  yAxis,
  collectionName,
  data,
  showSwitchBtn,
  isEnabled,
  trackKey,
  clientId,
  ...props
}) => {
  const [intervalSelected, setIntervalSelected] = useState('oneWeek');
  return (
    <ProgressGraphsBlock
      title={title}
      data={data}
      xAxis={xAxis}
      yAxis={yAxis}
      intervalSelected={intervalSelected}
      setIntervalSelected={setIntervalSelected}
      showSwitchBtn={showSwitchBtn}
      isEnabled={isEnabled}
      trackKey={trackKey}
      clientId={clientId}
      {...props}
    />
  );
};

export default ProgressGraphContainer;
